/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SafeDepositBoxBulkSyncRequest,
  SafeDepositBoxServiceRoleOptions,
  ServiceAgreementV2,
  ServiceRole,
  ServiceRoleBulkSyncRequest,
} from '../models/index';
import {
    SafeDepositBoxBulkSyncRequestFromJSON,
    SafeDepositBoxBulkSyncRequestToJSON,
    SafeDepositBoxServiceRoleOptionsFromJSON,
    SafeDepositBoxServiceRoleOptionsToJSON,
    ServiceAgreementV2FromJSON,
    ServiceAgreementV2ToJSON,
    ServiceRoleFromJSON,
    ServiceRoleToJSON,
    ServiceRoleBulkSyncRequestFromJSON,
    ServiceRoleBulkSyncRequestToJSON,
} from '../models/index';

export interface CreateServiceRoleRequest {
    serviceAgreementUid: string;
    serviceRole: ServiceRole;
}

export interface DeactivateOrDeleteServiceRoleRequest {
    serviceRoleUid: string;
}

export interface DeleteServiceRoleRequest {
    serviceRoleUid: string;
}

export interface GetSafeDepositBoxServiceRoleOptionsRequest {
    serviceAgreementUid: string;
}

export interface SyncSafeDepositBoxServiceRolesBulkRequest {
    serviceAgreementUid: string;
    safeDepositBoxBulkSyncRequest: SafeDepositBoxBulkSyncRequest;
}

export interface SyncServiceRolesBulkRequest {
    serviceAgreementUid: string;
    requestBody: Array<string>;
}

export interface SyncServiceRolesBulkWithContactNotesRequest {
    serviceAgreementUid: string;
    serviceRoleBulkSyncRequest: ServiceRoleBulkSyncRequest;
}

/**
 * 
 */
export class ServiceRoleApi extends runtime.BaseAPI {

    /**
     * Creates request options for createServiceRole without sending the request
     */
    async createServiceRoleRequestOpts(requestParameters: CreateServiceRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling createServiceRole().'
            );
        }

        if (requestParameters['serviceRole'] == null) {
            throw new runtime.RequiredError(
                'serviceRole',
                'Required parameter "serviceRole" was null or undefined when calling createServiceRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceRole/{serviceAgreementUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceRoleToJSON(requestParameters['serviceRole']),
        };
    }

    /**
     * create new service role for related service agreement. Stores information on DB and creates a new approval process for the provided service role.
     * create new service role
     */
    async createServiceRoleRaw(requestParameters: CreateServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.createServiceRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * create new service role for related service agreement. Stores information on DB and creates a new approval process for the provided service role.
     * create new service role
     */
    async createServiceRole(requestParameters: CreateServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.createServiceRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deactivateOrDeleteServiceRole without sending the request
     */
    async deactivateOrDeleteServiceRoleRequestOpts(requestParameters: DeactivateOrDeleteServiceRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceRoleUid'] == null) {
            throw new runtime.RequiredError(
                'serviceRoleUid',
                'Required parameter "serviceRoleUid" was null or undefined when calling deactivateOrDeleteServiceRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceRole/{serviceRoleUid}/deactivate`;
        urlPath = urlPath.replace(`{${"serviceRoleUid"}}`, encodeURIComponent(String(requestParameters['serviceRoleUid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * deactivate/logical-delete existing service role (and related workflow instances).
     * deactivate/logical-delete existing service role
     */
    async deactivateOrDeleteServiceRoleRaw(requestParameters: DeactivateOrDeleteServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.deactivateOrDeleteServiceRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * deactivate/logical-delete existing service role (and related workflow instances).
     * deactivate/logical-delete existing service role
     */
    async deactivateOrDeleteServiceRole(requestParameters: DeactivateOrDeleteServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.deactivateOrDeleteServiceRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteServiceRole without sending the request
     */
    async deleteServiceRoleRequestOpts(requestParameters: DeleteServiceRoleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceRoleUid'] == null) {
            throw new runtime.RequiredError(
                'serviceRoleUid',
                'Required parameter "serviceRoleUid" was null or undefined when calling deleteServiceRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceRole/{serviceRoleUid}`;
        urlPath = urlPath.replace(`{${"serviceRoleUid"}}`, encodeURIComponent(String(requestParameters['serviceRoleUid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * delete existing service role for related service agreement (and related workflow instances).
     * delete existing service role
     */
    async deleteServiceRoleRaw(requestParameters: DeleteServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.deleteServiceRoleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * delete existing service role for related service agreement (and related workflow instances).
     * delete existing service role
     */
    async deleteServiceRole(requestParameters: DeleteServiceRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.deleteServiceRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSafeDepositBoxServiceRoleOptions without sending the request
     */
    async getSafeDepositBoxServiceRoleOptionsRequestOpts(requestParameters: GetSafeDepositBoxServiceRoleOptionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling getSafeDepositBoxServiceRoleOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/serviceRole/safe-deposit-box/{serviceAgreementUid}/options`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * get Safe Deposit Box service-role options
     */
    async getSafeDepositBoxServiceRoleOptionsRaw(requestParameters: GetSafeDepositBoxServiceRoleOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SafeDepositBoxServiceRoleOptions>> {
        const requestOptions = await this.getSafeDepositBoxServiceRoleOptionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SafeDepositBoxServiceRoleOptionsFromJSON(jsonValue));
    }

    /**
     * get Safe Deposit Box service-role options
     */
    async getSafeDepositBoxServiceRoleOptions(requestParameters: GetSafeDepositBoxServiceRoleOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SafeDepositBoxServiceRoleOptions> {
        const response = await this.getSafeDepositBoxServiceRoleOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for syncSafeDepositBoxServiceRolesBulk without sending the request
     */
    async syncSafeDepositBoxServiceRolesBulkRequestOpts(requestParameters: SyncSafeDepositBoxServiceRolesBulkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling syncSafeDepositBoxServiceRolesBulk().'
            );
        }

        if (requestParameters['safeDepositBoxBulkSyncRequest'] == null) {
            throw new runtime.RequiredError(
                'safeDepositBoxBulkSyncRequest',
                'Required parameter "safeDepositBoxBulkSyncRequest" was null or undefined when calling syncSafeDepositBoxServiceRolesBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceRole/safe-deposit-box/bulk/{serviceAgreementUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SafeDepositBoxBulkSyncRequestToJSON(requestParameters['safeDepositBoxBulkSyncRequest']),
        };
    }

    /**
     * Replaces the desired Safe Deposit Box service-role snapshot for the service agreement. Existing non-removable roles must be included unchanged. Existing removable roles omitted from the request are removed. Capability flags are evaluated by the server and are not writable.
     * sync Safe Deposit Box service roles in bulk
     */
    async syncSafeDepositBoxServiceRolesBulkRaw(requestParameters: SyncSafeDepositBoxServiceRolesBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.syncSafeDepositBoxServiceRolesBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Replaces the desired Safe Deposit Box service-role snapshot for the service agreement. Existing non-removable roles must be included unchanged. Existing removable roles omitted from the request are removed. Capability flags are evaluated by the server and are not writable.
     * sync Safe Deposit Box service roles in bulk
     */
    async syncSafeDepositBoxServiceRolesBulk(requestParameters: SyncSafeDepositBoxServiceRolesBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.syncSafeDepositBoxServiceRolesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for syncServiceRolesBulk without sending the request
     */
    async syncServiceRolesBulkRequestOpts(requestParameters: SyncServiceRolesBulkRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling syncServiceRolesBulk().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling syncServiceRolesBulk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceRole/bulk/{serviceAgreementUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     * Synchronizes service roles for the related service agreement with the submitted partner identifiers. Missing service roles are created and existing service roles for partners absent from the request are submitted for deactivation.
     * sync service roles in bulk
     */
    async syncServiceRolesBulkRaw(requestParameters: SyncServiceRolesBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.syncServiceRolesBulkRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Synchronizes service roles for the related service agreement with the submitted partner identifiers. Missing service roles are created and existing service roles for partners absent from the request are submitted for deactivation.
     * sync service roles in bulk
     */
    async syncServiceRolesBulk(requestParameters: SyncServiceRolesBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.syncServiceRolesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for syncServiceRolesBulkWithContactNotes without sending the request
     */
    async syncServiceRolesBulkWithContactNotesRequestOpts(requestParameters: SyncServiceRolesBulkWithContactNotesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceAgreementUid'] == null) {
            throw new runtime.RequiredError(
                'serviceAgreementUid',
                'Required parameter "serviceAgreementUid" was null or undefined when calling syncServiceRolesBulkWithContactNotes().'
            );
        }

        if (requestParameters['serviceRoleBulkSyncRequest'] == null) {
            throw new runtime.RequiredError(
                'serviceRoleBulkSyncRequest',
                'Required parameter "serviceRoleBulkSyncRequest" was null or undefined when calling syncServiceRolesBulkWithContactNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/serviceRole/bulk/with-contact-notes/{serviceAgreementUid}`;
        urlPath = urlPath.replace(`{${"serviceAgreementUid"}}`, encodeURIComponent(String(requestParameters['serviceAgreementUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ServiceRoleBulkSyncRequestToJSON(requestParameters['serviceRoleBulkSyncRequest']),
        };
    }

    /**
     * Synchronizes service roles for the related service agreement with the submitted partner identifiers, optionally replacing the contact notes linked to the same service agreement in one transaction. Behaves like syncServiceRolesBulk for the service roles: missing service roles are created and existing service roles for partners absent from the request are submitted for deactivation. Use this operation when the contact notes must be linked atomically with the service roles, e.g. an active Debit Mastercard whose card holders may not change without a contact note. 
     * sync service roles in bulk together with contact notes
     */
    async syncServiceRolesBulkWithContactNotesRaw(requestParameters: SyncServiceRolesBulkWithContactNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ServiceAgreementV2>> {
        const requestOptions = await this.syncServiceRolesBulkWithContactNotesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ServiceAgreementV2FromJSON(jsonValue));
    }

    /**
     * Synchronizes service roles for the related service agreement with the submitted partner identifiers, optionally replacing the contact notes linked to the same service agreement in one transaction. Behaves like syncServiceRolesBulk for the service roles: missing service roles are created and existing service roles for partners absent from the request are submitted for deactivation. Use this operation when the contact notes must be linked atomically with the service roles, e.g. an active Debit Mastercard whose card holders may not change without a contact note. 
     * sync service roles in bulk together with contact notes
     */
    async syncServiceRolesBulkWithContactNotes(requestParameters: SyncServiceRolesBulkWithContactNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ServiceAgreementV2> {
        const response = await this.syncServiceRolesBulkWithContactNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
